import { ARTICLE_LIST_ITEM_SIZES, ArticleListItem } from '@/components/Article/Items/ArticleListItem';
import { ImageModule } from '@/components/Image/ImageModule';
import { useCurrentDate } from '@/cutils/context/TimeContext';
import { notNullOrUndefined } from '@/cutils/misc/notNullOrUndefined';
import { TrackEventDataType } from '@/types/tracking';
import { articleIsBreakingNews } from '@/utils/article/articleIsBreakingNews';

import { ArticleItemResultsItemFragment } from './__generated__/ArticleItemResultsItem.generated';

type Props = {
	article: ArticleItemResultsItemFragment;
	trackEventDataType: TrackEventDataType;
	className?: string;
};

const ArticleItemResultsItem = ({ article, trackEventDataType, className }: Props) => {
	const currentDate = useCurrentDate();
	const isBreakingNews = articleIsBreakingNews(article, currentDate);
	const modulesTypes = article.modulesTypes.filter(notNullOrUndefined);
	const imageComp = <ImageModule image={article.image} sizes={ARTICLE_LIST_ITEM_SIZES} />;

	return (
		<ArticleListItem
			className={className}
			image={imageComp}
			isBreakingNews={isBreakingNews}
			modulesTypes={modulesTypes}
			internalPath={article.path}
			publicationDate={article.publicationDate}
			teaserText={article.teaserText}
			title={article.title}
			trackEventDataType={trackEventDataType}
		/>
	);
};

export default ArticleItemResultsItem;
